import { ConfigFile as Config } from '@/Config';
const Version = () => {
    return (
        <div className='p-5'>CSR Version: <span className='font-bold'>{Config.version}</span></div>
    )
};

export default Version;
